<template>
  <div class="home" id="home">
    <!-- 头部 -->
    <el-header style="height: 10%; margin: 0">
      <div>
        <div class="imgcont">
          <img src="../assets/logo.png" alt />
        </div>

        <span>后台接口查看</span>
      </div>
      <el-button type="info" @click="logout">退出</el-button>
    </el-header>
    <!-- 主体 -->
    <el-container>
      <div class="document">
        <div class="custom-tree-container">
          <!-- 文档树（标题） -->
          <div class="block">
            <div class="search">
              <el-input
                placeholder="输入关键字进行搜索"
                clearable
                v-model="filterText"
              >
              </el-input>
            </div>
            <div class="catalog">目录</div>
            <el-tree
              :data="doucList"
              node-key="id"
              @node-click="handleNodeClick"
              :expand-on-click-node="true"
              :filter-node-method="filterNode"
              ref="tree"
              default-expand-all
              
            >
              <span class="custom-tree-node" slot-scope="{ data }">
                <span :class="docdata === data ? 'checked' : ''">{{
                  data.label
                }}</span>
              </span>
            </el-tree>
          </div>
          <!-- 右侧的文档 -->
          <div class="container">
            <div class="main" v-if="docdata !== null">
              <header class="header">
                <h1>
                  {{ docForm.base_info.title }}({{
                    docForm.base_info.title_chinese
                  }})
                </h1>
                <div class="date" v-if="docForm.base_info.update_time !== null">
                  更新时间：{{ docForm.base_info.update_time }}
                </div>
                <div class="date" v-else>
                  创建时间：{{ docForm.base_info.creat_time }}
                </div>
              </header>
              <div class="des">{{ docForm.base_info.note }}</div>
              <div class="res_url">
                <div class="title">请求地址</div>
                <div class="value">{{ docForm.base_info.api_url }}</div>
              </div>
              <div class="token">
                <div class="title">Token</div>
                <div class="value">
                  <span
                    v-if="docForm.base_info.is_token == 1"
                    class="token_need"
                    >需要</span
                  >
                  <span v-else class="token_need">不需要</span>
                </div>
              </div>

              <div class="data_sheet">
                <div class="title">关联表</div>
                <div class="value">
                <div class="data_cont" v-for="(item,index) in docForm.api_sqlform" :key="index">
                  <span>{{item.sql_name}}</span>
                  <div v-if="index+1!==docForm.api_sqlform.length">,</div>
                  <div v-else>.</div>
                </div>
                  <!-- <span v-for="(item, index) in docForm.api_sqlform" :key="index">{{ item.sql_name }}</span> -->
                </div>
              </div>
              <div class="inparams">
                <div class="title">请求参数 in</div>
                <div class="value">
                  <el-table :data="docForm.api_in" border stripe>
                    <el-table-column prop="name" label="参数"></el-table-column>
                    <el-table-column prop="type" label="类型"></el-table-column>
                    <el-table-column
                      prop="is_must"
                      label="是否必填"
                    ></el-table-column>

                    <!-- <el-table-column
                      prop="is_must"
                      label="是否必填"
                    ></el-table-column> -->
                    <el-table-column
                      prop="long"
                      label="最大长度"
                    ></el-table-column>
                    <el-table-column prop="note" label="描述"></el-table-column>
                    <el-table-column
                      prop="example"
                      label="示例值"
                    ></el-table-column>
                  </el-table>

                  <!-- <el-table :data="docForm.api_out" border stripe>
                  <el-table-column prop="name" label="参数"></el-table-column>
                  <el-table-column prop="type" label="类型"></el-table-column>
                  <el-table-column prop="note" label="描述"></el-table-column>
                  <el-table-column prop="example" label="示例值"></el-table-column>
                </el-table> -->
                </div>
              </div>

              <div class="outparams">
                <div class="title">请求参数 out</div>
                <div class="value">
                  <el-table :data="docForm.api_out" border stripe>
                    <el-table-column prop="name" label="参数"></el-table-column>
                    <el-table-column prop="type" label="类型"></el-table-column>
                    <el-table-column prop="note" label="描述"></el-table-column>
                    <el-table-column
                      prop="example"
                      label="示例值"
                    ></el-table-column>
                  </el-table>
                </div>
              </div>

              <div class="outparams">
                <div class="title">响应参数</div>
                <div class="value">
                  <el-table :data="docForm.api_response" border stripe>
                    <el-table-column prop="name" label="参数"></el-table-column>
                    <el-table-column prop="note" label="描述"></el-table-column>
                    <el-table-column
                      prop="message"
                      label="示例值"
                    ></el-table-column>
                  </el-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      doucList: null, //json格式的文档树
      filterText: "", //搜索框
      controllers: [], //控制器
      docdata: null, //当前选中文档
      docForm: {},
    };
  },

  created() {
    //获取文档树
    this.getTree();
  },
  watch: {
    //进行过滤
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  methods: {
    //获取文档树
    async getTree() {
      const { data: res } = await this.$http.post("/index/api_list", {});
      if (res.status !== 1) return this.$message.error("获取文档失败");
      this.doucList = res.data;
    },

    //选择左侧的tree文件
    handleNodeClick(data) {
      console.log("checkeddata", data);
      this.getDetail(data);
    },
    //获取当前文档的详细信息
    async getDetail(data) {
      // console.log(data.id);
      const { data: res } = await this.$http.post("/index/api_content", {
        id: data.id,
      });
      if (res.status !== 1) return this.$message.error("获取文档失败");

      // console.log(res);
      if (res.message === "该目录为主目录") {
      } else {
        this.docdata = data;
        this.docForm = res.data;
        // console.log(this.docForm.api_in)
        //遍历每一项api_in
        this.docForm.api_in.forEach((element) => {
          // console.log(element.is_must)
          element.is_must = element.is_must === 1 ? "是" : "否";
        });
        if (res.data.base_info === null) {
          this.docForm.base_info = "";
        }
      }
    },
    //search
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    logout() {
      // 清空token
      window.sessionStorage.clear();
      this.$router.push("/login");
    },
  },
};
</script>

<style scoped>
.home {
  height: 100%;
}

.el-container {
  /* height: 90%; */
}
.el-header {
  background-color: #373f41;
  display: flex;
  justify-content: space-between;
  padding-left: 0;
  align-items: center;
  color: #fff;
  font-size: 20px;
}
.el-header > div {
  display: flex;
  align-items: center;
}
.el-header > div img {
  height: 40px;
  width: 40px;
}
.el-header > div span {
  margin-left: 15px;
}
.main {
  margin-top: 10px;
}
.custom-tree-container {
  display: flex;
}
.search {
  margin: 20px 10px;
}
.imgcont {
  width: 40px;
  height: 40px;
  border-radius: 40px;
  overflow: hidden;
  margin-left: 30px;
}
.custom-tree-container {
  height: auto;
}
.document {
  width: 100%;
}
.block {
  width: 300px;
  /* height: 100%; */
  /* height: 100vh; */
  background-color: white;
  height: auto;

  border-right: 1px solid #dcdfe6;
}
.container {
  width: 100%;
  margin: 0;
  padding: 0 20px;
  /* border-left: 1px solid #DCDFE6; */
}
.header {
  border-bottom: 2px solid #dcdfe6;
  color: #303133;
}
.header h1 {
  display: flex;
  font-size: 20px;
}
.header .date {
  color: #909399;
  display: flex;
  font-size: 12px;
  margin: 10px 0;
}
.des {
  font-size: 14px;
  display: flex;
  color: #606266;
  /* background-color: #f2f6fc; */
  border-left: 10px solid #409eff;
  padding: 10px;
  padding-bottom: 40px;
  margin-top: 10px;
  /* border-left:10px solid #42b983; */
  background-color: #f8f8f8;
}
.title {
  font-size: 18px;
  display: flex;
  border-bottom: 1px solid #e4e7ed;
  font-weight: bold;
  color: #303133;
  margin: 10px 0;
}
.value {
  display: flex;
  font-size: 14px;
  margin-bottom: 40px;
}
.data_cont{
  display: flex;
  height: 24px;
}
.data_sheet span {
  color: #2973b7;
  font-weight: bold;
  padding: 2px 6px;
  margin: 0 5px;
  border-radius: 6px;
  background-color: #f8f8f8;
}
.catalog {
  width: 100%;
  display: flex;
  font-weight: bold;
  margin-left: 20px;
}
.checked {
  color: #409eff;
  font-weight: bold;
}
.token_need {
  background-color: #f8f8f8;
  /* color: #d63200; */
  color: #707070;
  padding: 2px 6px;
  font-weight: bold;
}
</style>
